<template>
    <div>
        <el-form ref="formRef" :model="form" label-width="150px" :rules="rules">
            <el-form-item label="分类" prop="categoryName">
                <el-input v-model="form.categoryName"></el-input>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="图片上传" prop="image">
                <div style="display: flex;">
                    <el-upload class="upload-demo" :action="this.uploadURL" style="text-align: left" :on-success="(response, file, fileList) =>
                        handleAvatarSuccess(response, file, fileList, 'file')
                        " accept=".png,.jpg,.jpeg,.gif,.bmp,.tif,.tiff" :limit="1" :on-remove="handleRemove">
                        <el-button size="small" type="primary" style="margin-top: 10px;">上传图片</el-button>
                    </el-upload>
                    <el-image style="width: 40px;height: 40px;margin-top: 6px;margin-left: 5px;"
                        :src="imgUrl + this.form.image" :preview-src-list="[imgUrl + form.image]" />
                </div>

            </el-form-item>
            <el-form-item label="标签" prop="label">
                <span>(标签以竖线相隔)</span>
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.label">
                </el-input>
            </el-form-item>
            <el-form-item style="display: flex;justify-content: center;margin-left: -150px;">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button @click="resetForm">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                categoryName: '',
                title: '',
                image: [],
                label: '',
                id: ''
            },
            rules: {
                categoryName: [
                    { required: true, message: '请输入分类', trigger: 'blur' }
                ],
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                image: [
                    { required: true, message: '请上传图片', trigger: 'blur' }
                ],
                label: [
                    { required: true, message: '请输入标签', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        onSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.form,
                    }
                    this.http.put('apij2/admin-api/voucher/large-screen-party-building-management/update', params).then((res) => {
                        if (res.data) {
                            this.resetForm()
                            this.$message({
                                message: '编辑成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: '请检查表单内容',
                                type: 'warning'
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: '请检查表单内容',
                        type: 'warning'
                    });
                }
            })

        },

        onClose() {
            this.$emit('onClose')
        },
        resetForm() {
            this.$emit('onSubmit')
            this.$refs.formRef.resetFields();
        },
        getData(row) {
            this.form = { ...row }
        },
        //上传文件事件
        handleAvatarSuccess(response, file, fileList, type) {
            this.form.image = response.data.store_result;
        },
        handleRemove() {
            this.form.image = '';
        },
    }
}   
</script>
<style scoped lang="scss">
span {
    color: #868686;
    font-size: 12px;
}

/deep/.upload-demo {
    border: none !important;
}
</style>